import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Configuración del proyecto de Firebase (NO MODIFICAR)
const firebaseConfig = {
  apiKey: "AIzaSyDHYqrtXR4wHd18vvRcq1MixrjKJjUyVoo",
  authDomain: "checklistliviano.firebaseapp.com",
  projectId: "checklistliviano",
  storageBucket: "checklistliviano.firebasestorage.app",
  messagingSenderId: "233916730112",
  appId: "1:233916730112:web:ff7caa1dcc02658d7381e5",
  measurementId: "G-DNFSK9FEB2"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Initialize Cloud Firestore
enableIndexedDbPersistence(db)
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      // Múltiples pestañas abiertas
    } else if (err.code === 'unimplemented') {
      // Navegador no compatible
    }
  });



export { db, auth, storage };